// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1rXL7","requiredAsterisk":"Info_requiredAsterisk__2YtuR"};